export default __webpack_public_path__ + "static/rightframe-59702d516f3f62ee2a68d2ca1f1a43b2.png";